var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { staticClass: "nav nav-tabs", attrs: { id: "myTab", role: "tablist" } },
      _vm._l(_vm.getYears, function(year, index) {
        return _c(
          "li",
          {
            key: year,
            staticClass: "nav-item",
            attrs: { role: "presentation" }
          },
          [
            _c(
              "button",
              {
                staticClass: "nav-link",
                class: index == 0 ? "active" : "",
                attrs: {
                  id: _vm.getYearButtonId(year),
                  "data-bs-toggle": "tab",
                  "data-bs-target": _vm.getTarget(year),
                  type: "button",
                  role: "tab",
                  "aria-controls": _vm.getTabId(year),
                  "aria-selected": index == 0
                }
              },
              [_vm._v("\n                " + _vm._s(year) + "\n            ")]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tab-content", attrs: { id: "priceTabContent" } },
      _vm._l(_vm.getYears, function(year, index) {
        return _c(
          "div",
          {
            key: year,
            staticClass: "tab-pane fade",
            class: index == 0 ? "show active" : "",
            attrs: {
              id: _vm.getTabId(year),
              role: "tabpanel",
              "aria-labelledby": _vm.getTabAreaLabel(year)
            }
          },
          [
            _c(
              "table",
              { staticClass: "table pricelist-table rental table-hover" },
              [
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      [
                        _c("td", [_vm._v(" ")]),
                        _vm._v(" "),
                        _vm._l(_vm.nightRanges, function(range) {
                          return _c(
                            "td",
                            { key: range, staticClass: "text-center" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.formatRange(range)) +
                                  " " +
                                  _vm._s(_vm.voMsg("tpl.text.nights")) +
                                  "\n                        "
                              )
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.seasonArray, function(season) {
                      return _vm.isDateInRange(season.fromdate, year)
                        ? _c(
                            "tr",
                            { key: season.fromdate, staticClass: "subrow" },
                            [
                              _c("td", { staticClass: "subinfo" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getFormattedDate(season.fromdate)
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.getFormattedDate(season.tilldate)
                                    ) +
                                    "\n                            "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", [_vm._v(_vm._s(season.season))])
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.nightRanges, function(range) {
                                return _c(
                                  "td",
                                  { key: range, staticClass: "text-center" },
                                  [
                                    _vm._v(
                                      "\n\n                            " +
                                        _vm._s(
                                          _vm.getCalculatedPrice(season[range])
                                        ) +
                                        "\n\n                        "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e()
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(0, true),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table pricelist-table table-hover" },
              _vm._l(_vm.priceArray, function(sg) {
                return sg.service.type != "RENT" ||
                  (sg.service.type == "RENT" && sg.service.surcharge)
                  ? _c(
                      "tbody",
                      { key: sg.service._id },
                      [
                        _c(
                          "tr",
                          {
                            class: { mainrow: sg.lines && sg.lines.length > 0 }
                          },
                          [
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(sg.service.name) +
                                  "\n\n                            "
                              ),
                              _c("small", [
                                sg.nightRange
                                  ? _c("span", [
                                      sg.nightRange.max < 99
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(sg.nightRange.min) +
                                                " - " +
                                                _vm._s(sg.nightRange.max) +
                                                "\n                                        " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.text.nights")
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      sg.nightRange.max > 99
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.startfrom")
                                                ) +
                                                "\n                                        " +
                                                _vm._s(sg.nightRange.min) +
                                                "\n                                        " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.text.nights")
                                                ) +
                                                "\n                                    "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                sg.guestRange
                                  ? _c("span", [
                                      sg.guestRange.max > 99
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                       " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.startfrom")
                                                ) +
                                                " " +
                                                _vm._s(sg.guestRange.min) +
                                                " " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.text.persons")
                                                ) +
                                                "\n                                     "
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      sg.guestRange.max < 99
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                                      " +
                                                _vm._s(sg.guestRange.min) +
                                                " - " +
                                                _vm._s(sg.guestRange.max) +
                                                " " +
                                                _vm._s(
                                                  _vm.voMsg("tpl.text.persons")
                                                ) +
                                                "\n                                     "
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              !sg.service.mandatory
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                (" +
                                        _vm._s(_vm.voMsg("tpl.text.optional")) +
                                        ")\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              sg.service.mandatory
                                ? _c("span", [_c("sup", [_vm._v("*")])])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-end" }, [
                              sg.service.calculation === "FLAT"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.voMsg("tpl.service.FLAT")) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              sg.service.calculation === "NIGHT"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.voMsg("tpl.service.NIGHT")) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              sg.service.calculation === "WEEK"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.voMsg("tpl.service.WEEK")) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              sg.service.calculation === "MONTH"
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.voMsg("tpl.service.MONTH")) +
                                        "\n                            "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-end price" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.getCalculatedPrice(sg.price)) +
                                  "\n                        "
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(sg.lines, function(price) {
                          return _vm.isDateInRange(price.fromdate, year)
                            ? _c(
                                "tr",
                                { key: price.sourceId, staticClass: "subrow" },
                                [
                                  _c("td", { staticClass: "subinfo" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.getFormattedDate(price.fromdate)
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm.getFormattedDate(price.tilldate)
                                        ) +
                                        "\n                            "
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("small", [_vm._v(_vm._s(price.season))])
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-end calc" }, [
                                    price.calculation === "FLAT"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.voMsg("tpl.service.FLAT")
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    price.calculation === "NIGHT"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.voMsg("tpl.service.NIGHT")
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    price.calculation === "WEEK"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.voMsg("tpl.service.WEEK")
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    price.calculation === "MONTH"
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.voMsg("tpl.service.MONTH")
                                              ) +
                                              "\n                            "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "text-end price" }, [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.getCalculatedPrice(price.value)
                                        ) +
                                        "\n                        "
                                    )
                                  ])
                                ]
                              )
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  : _vm._e()
              }),
              0
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "hint" }, [
      _c("i", {
        staticClass: "fa-sharp fa-light fa-circle-info",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" "),
      _c("sup", [_vm._v("*")]),
      _vm._v(_vm._s(_vm.voMsg("tpl.text.priceObligatory")) + "\n    ")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rental-hint" }, [
      _c("i", {
        staticClass: "fa-sharp fa-light fa-circle-info",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" Alle Preise verstehen sich in Euro pro Nacht.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }